import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { IPayoutsData, IPayoutsState } from 'store/payouts/types';

export const getPayoutsState = (state: RootState): IPayoutsState => state.payouts;

export const getPayoutsData = createSelector(
  [getPayoutsState],
  (state: IPayoutsState): IPayoutsData[] => state.data
);
